import { Body, Button, Dialog, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import { InnerLoading } from '../../../../components/InnerLoading'
import { useRemoveBill } from '../../utils/useRemoveBill'
import { Bill } from './Bills'

const RemoveAccountContainer = styled.div<{ $removed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s ease-out;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 0;
        `};
`

const SuccessContainer = styled.div<{ $removed?: boolean }>`
    position: absolute;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.2s ease-in;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 1;
        `};
`

const RemoveSuccess = ({ removed }: { removed: boolean }) => {
    return (
        <SuccessContainer $removed={removed}>
            <Body.Med size={12}>This bill has been successfully removed.</Body.Med>
        </SuccessContainer>
    )
}

type RemoveBillDialogProps = {
    bill: Bill | null
    onClose: () => void
}

export const RemoveBillDialog: React.VFC<RemoveBillDialogProps> = ({ onClose, bill }) => {
    const { removed, removeBill, loading } = useRemoveBill(bill)

    const handleCloseDialog = () => {
        if (loading) return
        onClose()
    }

    const handleRemoveAccount = async () => {
        if (!bill) return
        await removeBill()
    }

    return (
        <Dialog open={!!bill} onClose={handleCloseDialog}>
            <Dialog.Content minWidth={560}>
                <RemoveAccountContainer $removed={removed}>
                    {loading && <InnerLoading />}
                    <Spacer height={16} />
                    <Body.SmBold size={18}>Remove bill</Body.SmBold>
                    <Spacer height={16} />
                    <Body.Med size={14} style={{ textAlign: 'center' }}>
                        Are you sure you want to remove this bill?
                    </Body.Med>
                    <Spacer height={32} />
                    <Button.CTA
                        onClick={handleRemoveAccount}
                        variant="secondary"
                        style={{ width: '110px' }}
                    >
                        Remove
                    </Button.CTA>
                </RemoveAccountContainer>
                <RemoveSuccess removed={removed} />
            </Dialog.Content>
        </Dialog>
    )
}
